import React from 'react';
import { LoadingButton } from '@atlaskit/button';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { useSimpleSignupState } from '../../hook';
import { messages } from '../../messages';

type ButtonSubmitType = {
  isLoading: boolean;
  isDisabled: boolean;
};

export function ButtonSubmit({ isLoading, isDisabled }: ButtonSubmitType) {
  const { userInfo: { isLoggedIn } = { isLoggedIn: false } } =
    useSimpleSignupState();

  return (
    <StyledButton
      type="submit"
      appearance="primary"
      testId="simple-signup-button-submit"
      isLoading={isLoading}
      isDisabled={isDisabled || isLoading}
      shouldFitContainer
    >
      {isLoggedIn ? (
        // TODO: If this is needed, update message
        <FormattedMessage {...messages.submitButtonLabel} />
      ) : (
        <FormattedMessage {...messages.submitButtonLabel} />
      )}
    </StyledButton>
  );
}

const StyledButton = styled(LoadingButton)`
  height: 45px !important; // override Atlaskit styles

  span {
    align-self: center;
  }
`;
